import Service from './service'
import store from '../store'
import Axios from 'axios'

export default class WorkService {
  /**
   * Permet de récupérer le status d’un travail spécifique.
   * Retourne si tous les détails d’un travail sont validés et si un ou plusieurs détails d’un travail ont fait l’objet d’une remarque.
   * @param {string} numero
   */
  static async getStatus (numero) {
    try {
      await Service.verifyToken()
      return Service.api.get('/work/' + numero + '/status', {
        headers: Service.getAuthHeader(store.state.auth.user.token.accessToken)
      })
    } catch (error) {
      Service.handleError(error)
    }
  }
  /**
   * Modifie un travail spécifique.
   * La syntaxe de requête Axios pour les méthodes DELETE et PUT est différente de POST et GET
   * @param {Object} params
   */
  static async editWork (params) {
    try {
      await Service.verifyToken()
      return await Axios({
        method: 'put',
        url: `${Service.url}/work`,
        data: { ...params },
        headers: Service.getAuthHeader(store.state.auth.user.token.accessToken)
      })
    } catch (error) {
      Service.handleError(error)
    }
  }
  /**
   * Permet de récupérer tous les détails d’un travail spécifique passé en paramètre.
   * @param {string} numero
   */
  static async getDetails (numero) {
    try {
      await Service.verifyToken()
      return Service.api.get('/work/' + numero + '/details', {
        headers: Service.getAuthHeader(store.state.auth.user.token.accessToken)
      })
    } catch (error) {
      Service.handleError(error)
    }
  }
  /**
   * Permet de récupérer tous les détails dans une tranche de dates d’un travail spécifique passé en paramètre.
   * @param {string} numero
   * @param {string} fromDate
   * @param {string} toDate
   * @param {string} chronological
   */
  static async getDetailsInRange (numero, fromDate, toDate, chronological) {
    try {
      await Service.verifyToken()
      return Service.api.get(`/work/${numero}/details/${fromDate}/${toDate}/${chronological}`, {
        headers: Service.getAuthHeader(store.state.auth.user.token.accessToken)
      })
    } catch (error) {
      Service.handleError(error)
    }
  }
  /**
   * Permet de récupérer tous les travaux pour l’utilisateur spécifié en paramètre.
   * @param {string} login
   */
  static async getWorks (login) {
    try {
      await Service.verifyToken()
      return Service.api.get('/work/' + login, {
        headers: Service.getAuthHeader(store.state.auth.user.token.accessToken)
      })
    } catch (error) {
      Service.handleError(error)
    }
  }
  /**
   * Permet de récupérer un travail spécifique passé en paramètre.
   * @param {string} numero
   */
  static async getWork (numero) {
    try {
      await Service.verifyToken()
      return await Service.api.get('/work/' + numero, {
        headers: Service.getAuthHeader(store.state.auth.user.token.accessToken)
      })
    } catch (error) {
      Service.handleError(error)
    }
  }
  /**
   * Crée un travail pour l’utilisateur spécifié en paramètre.
   * @param {string} login
   */
  static async createWork (login, params) {
    try {
      await Service.verifyToken()
      return await Service.api.post('/work', {
        login: login,
        ...params
      }, {
        headers: Service.getAuthHeader(store.state.auth.user.token.accessToken)
      })
    } catch (error) {
      Service.handleError(error)
    }
  }
  /**
   * Supprime un travail spécifié en paramètre.
   * La syntaxe de requête Axios pour les méthodes DELETE et PUT est différente de POST et GET
   * @param {string} numero
   */
  static async removeWork (numero) {
    try {
      await Service.verifyToken()
      return await Axios({
        method: 'delete',
        url: `${Service.url}/work`,
        data: { numero: numero },
        headers: Service.getAuthHeader(store.state.auth.user.token.accessToken)
      })
    } catch (error) {
      Service.handleError(error)
    }
  }
}
